(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5615],{

/***/ 655:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[chain]",
      function () {
        return __webpack_require__(54723);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 54723:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _chain_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/primitives/index.ts + 15 modules
var primitives = __webpack_require__(92902);
// EXTERNAL MODULE: ./components/Layout.tsx
var Layout = __webpack_require__(51943);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js + 1 modules
var index_es = __webpack_require__(99603);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-brands-svg-icons/index.mjs
var free_brands_svg_icons = __webpack_require__(93024);
;// CONCATENATED MODULE: ./components/home/Footer.tsx




const SectionTitle = (param)=>/*#__PURE__*/ {
    let { title  } = param;
    return (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
        style: "subtitle1",
        css: {
            color: "$gray12",
            mb: 8
        },
        children: title
    });
};
const SectionLink = (param)=>/*#__PURE__*/ {
    let { name , href  } = param;
    return (0,jsx_runtime.jsx)(primitives/* Anchor */.ee, {
        target: "_blank",
        rel: "noopener noreferrer",
        href: href,
        weight: "medium",
        css: {
            fontSize: 14,
            mt: 16
        },
        children: name
    });
};
const developerSectionLinks = [
    {
        name: "OKINA Labs",
        href: "https://twitter.com/OKINALabs"
    },
    {
        name: "xMakeItMerch",
        href: "https://xmerch.xyz"
    }
];
const companySectionLinks = [
    {
        name: "SteezyApeGang",
        href: "https://marketplace-v2-khaki.vercel.app/ethereum/collection/0x70789e18a75611a9516d6251d650d096740a9e07"
    },
    {
        name: "HMN5",
        href: "https://marketplace-v2-khaki.vercel.app/ethereum/collection/0x32fc5bcabc1f78308be11754493c49116c0fa35f"
    },
    {
        name: "SteezyGenesis",
        href: "https://marketplace-v2-khaki.vercel.app/ethereum/collection/0x83296c35ac338ed6c4ab7db1bb3d6ca90ae3b9c7"
    }
];
const Footer = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
        justify: "between",
        css: {
            borderTop: "1px solid $gray7",
            borderStyle: "solid",
            pt: "$5",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: 36,
            "@bp600": {
                flexDirection: "row",
                gap: 0
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                css: {
                    gap: 80,
                    "@bp600": {
                        gap: 136
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        direction: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle, {
                                title: "Info"
                            }),
                            developerSectionLinks.map((props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(SectionLink, {
                                    ...props
                                }, props.name))
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        direction: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle, {
                                title: "Other"
                            }),
                            companySectionLinks.map((props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(SectionLink, {
                                    ...props
                                }, props.name))
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                direction: "column",
                css: {
                    alignItems: "flex-start",
                    "@bp600": {
                        alignItems: "flex-end"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle, {
                        title: "Join OKINA Labs Community"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                        css: {
                            gap: "$4",
                            mt: 16
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            target: "_blank",
                            rel: "noopener noreferrer",
                            href: "https://twitter.com/OKINALabs",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                                size: "xs",
                                color: "gray3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: free_brands_svg_icons/* faTwitter */.mdU,
                                    width: 14,
                                    height: 14
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/react-responsive/dist/react-responsive.js
var react_responsive = __webpack_require__(1852);
// EXTERNAL MODULE: ./hooks/index.ts + 5 modules
var hooks = __webpack_require__(35430);
// EXTERNAL MODULE: ./node_modules/@reservoir0x/reservoir-kit-ui/dist/index.module.js + 206 modules
var index_module = __webpack_require__(61897);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/common/ChainToggle.tsx
var ChainToggle = __webpack_require__(61955);
// EXTERNAL MODULE: ./components/common/CollectionsTimeDropdown.tsx
var CollectionsTimeDropdown = __webpack_require__(39968);
// EXTERNAL MODULE: ./components/Head.tsx
var Head = __webpack_require__(4049);
// EXTERNAL MODULE: ./components/rankings/CollectionRankingsTable.tsx
var CollectionRankingsTable = __webpack_require__(71567);
// EXTERNAL MODULE: ./context/ChainContextProvider.tsx
var ChainContextProvider = __webpack_require__(43810);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./pages/[chain]/index.tsx















const IndexPage = (param)=>{
    let { ssr  } = param;
    const isSSR = "object" === "undefined";
    const isMounted = (0,hooks/* useMounted */.s4)();
    const compactToggleNames = (0,react_responsive.useMediaQuery)({
        query: "(max-width: 800px)"
    });
    const [sortByTime, setSortByTime] = (0,react.useState)("1DayVolume");
    const marketplaceChain = (0,hooks/* useMarketplaceChain */.gw)();
    const router = (0,next_router.useRouter)();
    let collectionQuery = {
        limit: 10,
        sortBy: sortByTime,
        includeTopBid: true
    };
    const { chain , switchCurrentChain  } = (0,react.useContext)(ChainContextProvider/* ChainContext */.p);
    if (chain.collectionSetId) {
        collectionQuery.collectionsSetId = chain.collectionSetId;
    } else if (chain.community) {
        collectionQuery.community = chain.community;
    }
    const { data , isValidating  } = (0,index_module/* useCollections */.bX)(collectionQuery, {
        fallbackData: [
            ssr.collections[marketplaceChain.id]
        ]
    });
    let collections = data || [];
    let volumeKey = "allTime";
    switch(sortByTime){
        case "1DayVolume":
            volumeKey = "1day";
            break;
        case "7DayVolume":
            volumeKey = "7day";
            break;
        case "30DayVolume":
            volumeKey = "30day";
            break;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Box */.xu, {
                css: {
                    p: 24,
                    height: "100%",
                    "@bp800": {
                        p: "$6"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                        direction: "column",
                        css: {
                            mx: "auto",
                            maxWidth: 728,
                            pt: "$5",
                            textAlign: "center",
                            alignItems: "flex-start",
                            "@bp600": {
                                alignItems: "center"
                            }
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        css: {
                            my: "$6",
                            gap: 65
                        },
                        direction: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                justify: "between",
                                align: "start",
                                css: {
                                    flexDirection: "column",
                                    gap: 24,
                                    "@bp800": {
                                        alignItems: "center",
                                        flexDirection: "row"
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        style: "h4",
                                        as: "h4",
                                        children: "OKINA Labs Collections"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                        align: "center",
                                        css: {
                                            gap: "$4"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionsTimeDropdown/* default */.Z, {
                                                compact: compactToggleNames && isMounted,
                                                option: sortByTime,
                                                onOptionSelected: (option)=>{
                                                    setSortByTime(option);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChainToggle/* default */.Z, {})
                                        ]
                                    })
                                ]
                            }),
                            isSSR || !isMounted ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionRankingsTable/* CollectionRankingsTable */.D, {
                                collections: collections,
                                loading: isValidating,
                                volumeKey: volumeKey
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                css: {
                                    alignSelf: "center"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/".concat(marketplaceChain.routePrefix, "/collection-rankings"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                                        css: {
                                            minWidth: 224,
                                            justifyContent: "center"
                                        },
                                        size: "large",
                                        children: "View All"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {})
                ]
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _chain_ = (IndexPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7948,8421,8957,1943,1236,9774,2888,179], function() { return __webpack_exec__(655); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);